import {useState, useRef, useEffect, createContext} from 'react';

type WindowsState = {
  upload: HTMLElement;
};

export const WindowsCtx = createContext<WindowsState>({
  upload: null!,
});

type Props = {
  children: React.ReactNode;
};
export const WindowsProvider = (props: Props) => {
  const [windowsTargets, setWindowsTargets] = useState<WindowsState>(null!);
  const uploadRef = useRef<HTMLDivElement>(null!);

  // ensure dom elements are saved
  // TODO: this will be removed when chakra-ui is implemented
  useEffect(() => {
    setWindowsTargets({
      upload: uploadRef.current,
    });
  }, []);

  return (
    <>
      {windowsTargets && (
        <WindowsCtx.Provider value={windowsTargets}>
          {props.children}
        </WindowsCtx.Provider>
      )}

      <div ref={uploadRef} />
    </>
  );
};
